import React, { useState, useEffect } from "react";
import { inject } from "mobx-react";
import PropTypes from "prop-types";
import { LIMITREVIEWTEXT } from "Constants/Limit";
import { ReviewItemV2 } from "ComponentsUI/Reviews";

const ReviewContainerV3 = (props) => {
	const {
		ApplicationModel: { text },
		review,
		type,
		reviewsShowLength,
		position,
		defaultUserName,
		onlyReviewsStyle,
	} = props;
	let userName;
	const [isSSR, setIsSSR] = useState(true);
	let [showFullReview, setShowFullReview] = useState(
		review?.review?.length > LIMITREVIEWTEXT || review.text?.length > LIMITREVIEWTEXT
	);

	useEffect(() => {
		setIsSSR(() => false);
	}, []);

	const showButton =
		review?.review?.length > LIMITREVIEWTEXT || review.text?.length > LIMITREVIEWTEXT;
	let currentReview, currentDate;

	if (!review) {
		return null;
	}

	if (type === "answer") {
		currentReview = {
			date: review.date,
			author: review.user,
			review: review.text,
		};
	} else {
		currentReview = review;
	}

	if (+currentReview.author.name == currentReview.id) {
		userName = defaultUserName;
	} else {
		userName = currentReview.author.name;
	}

	if (Boolean(currentReview?.date)) {
		let reviewDateStamp = new Date(currentReview?.date);
		currentDate = reviewDateStamp.toLocaleString("default", {
			day: "numeric",
			month: "long",
			year: "numeric",
		});
	}

	const showFullReviewHandler = (e) => {
		e.stopPropagation();
		setShowFullReview((showFullReview) => !showFullReview);
	};
	return (
		<ReviewItemV2
			id={currentReview.id}
			name={userName}
			avatar={currentReview.author?.photo}
			providerName={currentReview.provider?.name}
			date={currentDate}
			reviewText={currentReview.review}
			proofed={Boolean(currentReview.real)}
			answers={currentReview.answers?.list}
			onlyReviewsStyle={onlyReviewsStyle}
			isSSR={isSSR}
			type={type}
			text={text}
			reviewsShowLength={reviewsShowLength}
			position={position}
			showButton={showButton}
			showFullReview={showFullReview}
			showFullReviewHandler={(e) => showFullReviewHandler(e)}
		/>
	);
};

ReviewContainerV3.propTypes = {
	review: PropTypes.object,
	type: PropTypes.string.isRequired,
	reviewsShowLength: PropTypes.number,
	position: PropTypes.number,
	defaultUserName: PropTypes.string,
	onlyReviewsStyle: PropTypes.bool,
};

export default inject("ApplicationModel")(ReviewContainerV3);
